import styled from 'styled-components'
import CustomNavLink from '../../Elements/link/NavLink'
import { theme } from '../../../style/theme'
import { colorTheme } from '../../../style/theme/colorTheme'

export const NavBarSettings = styled.div`
	margin-top: auto;
	margin-bottom: 2.25em;
	padding: 0 1em;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	transition: all .2s;
	column-gap: 0.2em;
	row-gap: 0.25em;

	&.toggled {
		padding: 0 0.63em;
		margin-bottom: 1em;
	}

	@media screen and (max-width: ${theme.point820}) {
		margin: 2.14em;
	}

	@media screen and (max-width: ${theme.point720}) {
		margin-top: 1.88em;
	}
`
NavBarSettings.displayName = 'NavBarSettings'

export const SettingItem = styled(CustomNavLink)`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 2.63em;
	height: 1.63em;
	border-radius: 0.38em;
	background-color: ${colorTheme.navBar.settingsItem.background};
	cursor: pointer;
	text-decoration: none;
	color: ${colorTheme.navBar.settingsItem.title};
	line-height: initial;

	img {
		width: 40%;
	}

	&.toggled {
		width: 2.5em;
		height: 1.56em;
	}

	&.green {
		background-color: ${colorTheme.navBar.settingsItem.green.background};
	}
`
SettingItem.displayName = 'SettingItem'

export const TseSettingItem = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 2.63em;
	height: 1.63em;
	border-radius: 0.38em;
	background-color: ${colorTheme.navBar.settingsItem.background};
	cursor: pointer;
	text-decoration: none;
	color: ${colorTheme.navBar.settingsItem.title};
	line-height: initial;
	user-select: none;

	img {
		width: 40%;
	}

	&.toggled {
		width: 2.5em;
		height: 1.56em;
	}

	&.green {
		background-color: ${colorTheme.navBar.settingsItem.green.background};
	}
`
TseSettingItem.displayName = 'TseSettingItem'
